<div class="driver-sos-description">

  <div class="driver-sos-description__image">
    <img [src]="descriptionConfig.imageUrl" alt="">
  </div>

  <div class="driver-sos-description__letter text-primary">
    {{ descriptionConfig.letter }}
  </div>

  <div  class="driver-sos-description__text"
        [innerHTML]="descriptionConfig.text | translate | safeHtml">
  </div>
</div>
